import React, { useCallback, useEffect } from 'react'
import Cookies from 'js-cookie'
import { Form, Field } from 'react-final-form'
import { Button, InputField, CheckboxField } from '@mc/design-system'
import {
  getCheckboxState,
  NOT_VISIBLE_CHECKED,
  VISIBLE_CHECKED,
} from '@mc/gdpr'
import { useTranslation, Trans } from '@mc/i18n'
import { track, getPageSource, EventTypes } from '@mc/track-event'
import { isGiftAccountClarificationOn } from '../../utils'
import { validateRegister } from '../../validations'

const FormFields = (props) => {
  const { onSubmit, onLoginClick } = props

  const { t } = useTranslation('@mc/authentication')
  const emailCapture = getCheckboxState()

  const trackMarketingConsent = useCallback(({ checked, isDefault }) => {
    track(EventTypes.MARKETING_CONSENT_SET, {
      ...(isDefault && { default: true }),
      ...(checked !== undefined && { checked }),
      location: 'authentication_modal',
      page_source: getPageSource(),
    })
  }, [])

  useEffect(() => {
    if (emailCapture === VISIBLE_CHECKED) {
      trackMarketingConsent({ isDefault: true })
    }
  }, [emailCapture, trackMarketingConsent])

  const renderSignInMessage = () => (
    <p className='mc-text--center mc-my-4'>
      <Trans i18nKey='registerForm.signIn' ns='@mc/authentication'>
        <a className='mc-text--link' onClick={onLoginClick} />
      </Trans>
    </p>
  )

  return (
    <Form
      initialValues={{
        email: Cookies.get('cart_email')?.replace(/['"]+/g, ''),
        gdprOptIn: [NOT_VISIBLE_CHECKED, VISIBLE_CHECKED].includes(
          emailCapture,
        ),
      }}
      onSubmit={onSubmit}
      validate={validateRegister}
      render={({ handleSubmit, submitting, submitError }) => (
        <form onSubmit={handleSubmit}>
          {!submitting && submitError && (
            <p
              aria-live='assertive'
              className='mc-text--error mc-text--center mc-mb-4'
            >
              {submitError}
            </p>
          )}
          <Field
            component={InputField}
            className='mc-mb-4'
            id='email'
            type='email'
            name='email'
            label='Email'
            data-ba='email-input'
            autoComplete='email'
            required
          />
          <Field
            data-ba='password-input'
            component={InputField}
            className='mc-mb-4'
            id='password'
            type='password'
            name='password'
            label='Password'
            autoComplete='new-password'
            required
          />
          {emailCapture && emailCapture !== NOT_VISIBLE_CHECKED && (
            <Field name='gdprOptIn'>
              {(fieldProps) => (
                <CheckboxField
                  {...fieldProps}
                  className='mc-mb-4 mc-text-small'
                  label='I agree to receive marketing emails about MasterClass courses and related learning products'
                  onChange={(value) => {
                    fieldProps.input.onChange(value)
                    trackMarketingConsent({ checked: value })
                  }}
                />
              )}
            </Field>
          )}

          {isGiftAccountClarificationOn() ? (
            <>
              <Trans i18nKey='giftSignUpTerms' ns='@mc/authentication'>
                <p className='mc-text-x-small mc-text--center mc-opacity--muted mc-my-4'>
                  <a
                    className='mc-text--link mc-text--nowrap'
                    href='/privacy'
                  ></a>
                  <a
                    className='mc-text--link mc-text--nowrap'
                    href='/terms'
                  ></a>
                </p>
              </Trans>
            </>
          ) : (
            <>
              <p className='mc-text-x-small mc-text--center mc-opacity--muted mc-my-4'>
                <Trans i18nKey='registerForm.terms' ns='@mc/authentication'>
                  <span>
                    <br></br>
                    <a className='mc-text--link' href='/privacy' />
                    <a className='mc-text--link' href='/terms' />
                    <q />
                  </span>
                </Trans>
              </p>
            </>
          )}

          <Button
            data-ba='submit-btn'
            type='submit'
            loading={submitting}
            fullWidth
          >
            {isGiftAccountClarificationOn()
              ? t('activateGift')
              : t('createAccount')}
          </Button>

          {renderSignInMessage()}
        </form>
      )}
    />
  )
}
export default FormFields
